// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

import get from "../../utils/GetNested";

export const GetWorkflowTemplate = CreateProcess({
	method: "GET",
	name: "GetWorkflowTemplate",
	type: "WORKFLOWS:TEMPLATE.GET",

	request: (props) => ({
		url: `/api/workflow-templates/${props.workflowTemplateID}/`,
	}),

	success: (response) =>
		fromJS({
			template: response.data.template,
			templateActorsMap: response.data.display_user_map,
			templateSignaturesMap: response.data.signature_request_map,
		}),
});

export const GetWorkflowTemplates = CreateProcess({
	method: "GET",
	name: "GetWorkflowTemplates",
	type: "WORKFLOWS:TEMPLATES.GET",

	request: (props) => {
		const workflowTemplateName = get(props, ["params", "payload", "name"], props.name) || "";

		return {
			url: `/api/workflow-templates/?name=${workflowTemplateName}`,
		};
	},

	success: (response) => response.data,
});
